
































































































































































































import Vue from "vue";
import ResourceItemList from "@/components/ResourceItemList.vue";
import MapPage from "../pages/Index.vue";

import { titleize } from "underscore.string";
import { mapState } from "vuex";
import { firestore } from "firebase";

export default Vue.extend({
  metaInfo() {
    return {
      title: this.resource,
    };
  },
  name: "resource-page",
  components: { MapPage, ResourceItemList },
  props: {
    resource: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      fullscreen: false,
      firstVisible: null as any,
      lastVisible: null as any,
      autoRefresh: false as boolean,
      items: [] as any[],
      hiddenItems: [] as any[],
      visibleItems: [] as any[],
      loading: true,
      menu: null as null | string,
      menus: {
        pageSize: {
          title: "PageSize",
          value: 25 as number,
        },
        filter: {
          title: "Filter",
          fields: {},
        },
        search: {
          title: "Search",
          value: "",
        },
        sort: {
          title: "Sort",
          field: "name",
          direction: "asc",
        },
      },
      pageScrollTop: 0,
      query: {
        limit: 12,
        orderBy: {
          field: "name",
          order: undefined,
        },
      },
      scrollingDown: false,
      unsubscribe: () => null as any,
    };
  },

  computed: {
    filterFields(): object[] {
      const fields = Object.entries(this.schema).filter(
        ([key, field]) => field.options != undefined
      );
      if (this.resource == "views") {
        fields.push(["upToDate", this.upToDateField()]);
      }
      return fields;
    },
    sortFields(): object[] {
      const fields =
        Object.entries(this.schema).filter(([key, field]) => field.sortable) ||
        [];
      if (this.resource == "views") {
        fields.push(["upToDate", this.upToDateField()]);
      }
      return fields;
    },
    schema(): { [key: string]: any }[] {
      return this["schemas"][this.resource];
    },
    ...mapState(["schemas"]),
    viewsDisplay(): string {
      return this.$store.state.viewsDisplay;
    }
  },

  methods: {
    clearMenus() {
      //console.log("clearMenus");
      
      const defaults = this.schema['defaults'];
      const defaultSortValue = defaults != undefined ? defaults['sort'] : "";
      //const defaultfield = defaults != undefined ? defaults['field'] : "";
      //const defaultfieldValue = defaults != undefined ? defaults['fieldvalue'] : "";
      this.$set(this.menus.filter, "fields",{});
      this.$set(this.menus.sort, "field", defaultSortValue);
      this.$set(this.menus.sort, "direction", "desc");
      this.$set(this.menus.search, "value", "");
      history.pushState(
        {},
        document.title,
        this.$route.path + this.queryString()
      );
      var fireBaseQuery = this.GetBaseQuery();
      fireBaseQuery = this.ApplyLimit(fireBaseQuery);
      this.GetData(fireBaseQuery);
    },
    applyPageSize(pageSize:number)
    {
      //console.log("Apply page size" + pageSize);
      
      this.menus.pageSize.value = pageSize;
      var fireBaseQuery = this.GetBaseQuery();
      fireBaseQuery = this.ApplyLimit(fireBaseQuery);
      this.GetData(fireBaseQuery);
    },
    nextPage() {      
      //console.log("Next Page");
      var fireBaseQuery = this.GetBaseQuery();  
      if(this.lastVisible != null)
      {
        fireBaseQuery = fireBaseQuery.startAfter(this.lastVisible);      
      }    
      fireBaseQuery = this.ApplyLimit(fireBaseQuery);
      this.GetData(fireBaseQuery);
    },
    previousPage() {      
      //console.log("Previous Page");
      var fireBaseQuery = this.GetBaseQuery();
      if(this.firstVisible != null)
      {
          fireBaseQuery = fireBaseQuery.endBefore(this.firstVisible);
      }  
      fireBaseQuery = this.ApplyLimit(fireBaseQuery, false);
      
      this.GetData(fireBaseQuery);
    },
    focusSearch() {
      //console.log("Focus Search");
      
      this.menu == "search" ? (this.menu = null) : (this.menu = "search");
      const searchInput = document.getElementById("searchInput");
      const focusSearchInput = setInterval(() => {
        if (searchInput) {
          searchInput.focus();
          clearInterval(focusSearchInput);
        }
      }, 50);
    },
    pageScroll(event) {
      if (event.target.scrollTop > this.pageScrollTop) {
        this.scrollingDown = true;
        this.$emit("scrollingDown", true);
      } else {
        this.scrollingDown = false;
        this.$emit("scrollingDown", false);
      }
      this.pageScrollTop = event.target.scrollTop;
    },
    queryString(): string {
      const params = [] as string[];

      const filters = Object.entries(this.menus.filter.fields).filter(
        ([key, value]) => typeof value !== "undefined"
      );
      if (filters.length) {
        params.push(
          "filter=" + filters.map(([key, value]) => `${key}:${value}`).join(",")
        );
      }

      const search = this.menus.search.value;
      if (search) {
        params.push(`search=${this.menus.search.value}`);
      }

      const sort = this.menus.sort.field;
      if (sort) {
        params.push(
          `sort=${this.menus.sort.field},${this.menus.sort.direction || "asc"}`
        );
      }

      return params.length ? "?" + params.join("&") : "";
    },
    searchInput(search: string) {
      //console.log("Search Input");
      
      history.pushState(
        {},
        document.title,
        this.$route.path + this.queryString()
      );
      if (search.length > 0) {
        const words = search.toLowerCase().split(";");
        const items = this.items.filter((item) => {
          return words.every(
            (string) =>
              JSON.stringify(Object.values(item))
                .toLowerCase()
                .indexOf(string.trim()) > -1
          );
        });
        this.visibleItems = items;
      }
      else
      {
        var fireBaseQuery = this.GetBaseQuery();
        fireBaseQuery = this.ApplyLimit(fireBaseQuery);
        this.GetData(fireBaseQuery);
      }
      this.menus.search.value = search;
      this.loading = false;
    },
    ApplyLimit(query, nextPage:boolean = true)
    {      
      const tmpPageSize:number = this.menus.pageSize.value;
      //console.log("Apply Limit: " + tmpPageSize);      
      if(tmpPageSize == -1)
      {
        return query;
      }
      if(nextPage == false)
      {        
        return query.limitToLast(Number(tmpPageSize));
      }
      return query.limit(Number(tmpPageSize));
    },
    
    GetBaseQuery() {
      //console.log("Get base query.");
      
      this.items = [];
      this.loading = true;
      var query:any = undefined;
      const fields = Object.entries(this.menus.filter.fields);
      const sortField:string = this.menus.sort.field;
      const sortDirection:string = this.menus.sort.direction;

      if (this.$store.state.auth.token.claims.super) {
        query = this.$db.collection(this.resource);
      } else if (this.$store.state.auth.token.claims.partner) {
        const partnerId = this.$store.state.auth.token.claims.partner;
        query = this.$db
          .collection(this.resource)
          .where("partners", "array-contains", partnerId);
      } else if (this.$store.state.auth.token.claims.client) {
        const clientId = this.$store.state.auth.token.claims.client;
        query = this.$db
          .collection(this.resource)
          .where("clients", "array-contains", clientId);
      } else {
        query = this.$db
          .collection(this.resource)
          .where("users", "array-contains", this.$store.getters.user.id);
      }
      
      if (fields.length) {
        fields.forEach((field) => {
          //console.log("Filtering on: " + field[0] + " where equals: "+ field[1]);          
          query = query.where(field[0], "==", field[1]);
        });
      }

      if (sortField && fields.some(e => e[0] === sortField) === false) {
        //console.log("Sorting using field: " + sortField + " direction: " + sortDirection);        
        query = query.orderBy(sortField, sortDirection);
      }
      return query;
    },
    toggleAutoRefresh()
    {
      //console.log("toggle auto refresh");
      
      if(this.autoRefresh == true)
      {
      //console.log("enable auto refresh");
        this.enableAutoRefresh();
        return;
      }
      //console.log("disable auto refresh");
      this.disableAutoRefresh();
    },
    disableAutoRefresh()
    {
      this.unsubscribe();
    },
    enableAutoRefresh()
    {
      var fireBaseQuery = this.GetBaseQuery();
      fireBaseQuery = this.ApplyLimit(fireBaseQuery);
       this.unsubscribe = fireBaseQuery.onSnapshot(
        (snapshot: firestore.QuerySnapshot) => {
          if (snapshot.docChanges().length) {
            //console.log(snapshot.docChanges().length + " Changes detected");
            var fireBaseQuery = this.GetBaseQuery();
            fireBaseQuery = this.ApplyLimit(fireBaseQuery);
            this.GetData(fireBaseQuery);
          }
          this.loading = false;
        }
      );
    },
    upToDateField() {
      return {
        label: "Up To Date?",
        options: [
          {
            value: 0,
            label: "Not Up To Date",
          },
          {
            value: 1,
            label: "Up To Date",
          },
        ],
        fieldTag: "select",
        fieldType: "option",
      };
    },
    async GetData(query)
    {
      const data = await query
      .get()
      .then((querySnapshot) => {
        const firstVisible = querySnapshot.docs[0]; 
        const lastVisible = querySnapshot.docs[querySnapshot.docs.length-1];
        if(firstVisible != null)
        {
          this.firstVisible = firstVisible;
        }
        if(lastVisible != null)
        {
          this.lastVisible = lastVisible;
        }
        querySnapshot.forEach((doc) => {
            const item: { [key: string]: any } = {
              _id: doc.id,
              ...doc.data(),
              };
            const index = this.items.findIndex((_item) => {
                 return _item._id == item._id;
               });
               if (index > -1) {
                 this.$set(this.items, index, item);
               } else {
                 this.$set(this.items, this.items.length, item);
               }
            });
          })
      .catch((error) => {
        //console.error(error);        
      });
      //console.log("Found " + this.items.length + " from query.");
      this.visibleItems = this.items;
      this.loading = false;
    },
    async init() { 
      //const defaults = this.schema['defaults'];
      //const defaultSortValue = defaults != undefined ? defaults['sort'] : "";
      this.items = [];
      this.loading = true;
      const query = new URLSearchParams(decodeURI(window.location.search));
      if (query.get("filter")) {
        const filterString = query.get("filter") || "";
        //window.console.log({ filterString });
        const filters = filterString.split(",").forEach((filterPart) => {
          const filter = filterPart.split(":");
          if (filter.length === 2) {
            this.menus.filter.fields[filter[0]] = filter[1];
          }
        });
      } else {
        //this.menus.filter.fields = {"stage": 2};
      }

      this.menus.search.value = query.get("search") || "";

      if (query.get("sort")) {
        const sort = query.get("sort") || "";
        //window.console.log({ sort });
        this.menus.sort.field = sort.split(",")[0];
        this.menus.sort.direction =
          sort.split(",")[1] === "asc" || sort.split(",")[1] === "desc"
            ? sort.split(",")[1]
            : this.menus.sort.direction;
      } else {
        this.menus.sort.field = "";
        this.menus.sort.direction = "asc";
      }
      var fireBaseQuery = this.GetBaseQuery();
      fireBaseQuery = this.ApplyLimit(fireBaseQuery);
      
      await this.GetData(fireBaseQuery);
      this.searchInput(this.menus.search.value);
    },
    
    popstateListener(event) {
      this.loading = true;
      this.init();
    },
  },

  watch: {
    resource() {
      this.init();
    },
  },

  filters: {},
  created() {
    this.loading = true;
    this.init();
    
    window.addEventListener("popstate", this.popstateListener);
  },
  mounted() {
  },
  updated() {},
  beforeDestroy() {
    this.unsubscribe();
    window.removeEventListener("popstate", this.popstateListener);
  },
});
